/** Shared political party colors for forecast charts and the power index. */
export const REPUBLICAN_COLOR = '#ff3333';
export const DEMOCRATIC_COLOR = '#265cff';
export const SPLIT_CONTROL_COLOR = '#aa00ff';

/** Balance of Power chart lines, keyed by `getBalanceOfPowerColorKey`'s outcome. */
export const BALANCE_OF_POWER_COLORS = {
    Red: REPUBLICAN_COLOR,
    Blue: DEMOCRATIC_COLOR,
    Purple: SPLIT_CONTROL_COLOR,
} as const;
